import { render, staticRenderFns } from "./OrderableProductBundleData.vue?vue&type=template&id=5d72e280&"
import script from "./OrderableProductBundleData.vue?vue&type=script&lang=ts&"
export * from "./OrderableProductBundleData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports